import { Directive, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';

import { PlatformService } from './platform.service';

@Directive({
  selector: '[shrdUtcIfPlatformBrowser]'
})
export class PlatformBrowserDirective implements OnInit {
  constructor(
    private readonly templateRef: TemplateRef<unknown>,
    private readonly viewContainer: ViewContainerRef,
    private readonly platform: PlatformService
  ) {}

  ngOnInit() {
    this.platform.isBrowser ? this.viewContainer.createEmbeddedView(this.templateRef) : this.viewContainer.clear();
  }
}
